import React, { SyntheticEvent, useState } from "react";
import BootstrapTable, { SelectRowProps } from 'react-bootstrap-table-next';

const Grid = (props: any) => {
    const defaultSelectRowProps:SelectRowProps<any> = {
        mode: 'radio',
        clickToSelect: true,
        bgColor:"#d9d9d1",
        hideSelectColumn: true
      }
      
    return (
        <React.Fragment>
          
            <BootstrapTable
                keyField={props.keyField}
                data={props.data}
                columns={props.columns}
                selectRow={props.selectRow ?? defaultSelectRowProps}
            />
            {props.children}
        </React.Fragment>
    );
}

export default Grid


